<template>
    <div>
        <v-card-text>
            <div
                    v-for="p in productListByTopic(topic.index)"
                    :key="p.col"
                    v-if="p.points > 0"
                    class="product-in-topic"
            >
                <product-bar-in-topic :product="p"></product-bar-in-topic>
            </div>
        </v-card-text>
    </div>


</template>

<script>
    import { mapGetters } from "vuex";
    import ProductBarInTopic from "./ProductBarInTopic";

    export default {
        name: "Topic",
        props: ['topic'],
        components: { ProductBarInTopic },
        computed: {
            ...mapGetters("qa", {
                productListByTopic: 'getRecommendedProductsByTopic'
            })
        }
    }
</script>

<style >
    .product-in-topic {
        margin-left: 0;
        margin-right: 1em;
        padding-left: 0;
        display:inline-grid;
    }

    @media only screen and (min-width: 600px) {
        .product-in-topic {
            margin-left: 1em;
        }
        .product-in-topic:first-of-type {
            margin-left: 0;
        }
    }

    .product-card {
        border-radius: 10px;
    }
    .product-bar-in-topic {

    }
    div.v-expansion-panel__header {
        background-color: #CCD5ED !important;
        border-radius: 3em !important;
        padding: 1em 2em;
        margin-top: 1em;
        text-align: center;
        font-size: 18px !important;
        color: #002EA7 !important;
    }
    ul.v-expansion-panel {
        box-shadow: none;
    }
    li.v-expansion-panel__container {
        border-top-left-radius: 31px;
        border-top-right-radius: 31px;
        border-bottom-right-radius: 31px;
        border-bottom-left-radius: 31px;
        margin-bottom: 0.5em;
    }
    div.v-expansion-panel__header {
        margin-top: 0;
    }

</style>
